import { DATE_FORMAT_API } from '@/constants/dateTimeFormats';
import moment from 'moment';

const initialState = {
    athleteModel: {
        athleteErgoProgress: [],
        athleteErgoProgressFilterFields: [],
        athleteId: null
    },

    filterModel: {
        startDate: moment().subtract(1, 'months').format(DATE_FORMAT_API),
        endDate: moment().format(DATE_FORMAT_API),
        distanceId: [],
        timesId: [],
        intensitiesId: [],
        byErgoId: [],
        tags: [],
        focuses: []
    },

    tabsSelectPieceName: 0
};

export const reportsErgo = {
    namespaced: true,

    state: Object.assign({}, initialState),

    getters: {
        getAthleteDataModel(state) {
            return state.athleteModel;
        },

        getFilterModel(state) {
            return state.filterModel;
        },

        getTabsSelectPieceName(state) {
            return state.tabsSelectPieceName;
        }
    },

    actions: {
        resetState(context) {
            context.state = Object.assign({}, initialState);
        },

        setAthleteData(context, payload) {
            Vue.set(context.state.athleteModel, 'athleteErgoProgress', payload.athleteErgoProgress);
            Vue.set(
                context.state.athleteModel,
                'athleteErgoProgressFilterFields',
                payload.athleteErgoProgressFilterFields
            );
            Vue.set(context.state.athleteModel, 'athleteId', payload.athleteId);
        },

        setStartDate(context, payload) {
            Vue.set(context.state.filterModel, 'startDate', payload);
        },

        setEndDate(context, payload) {
            Vue.set(context.state.filterModel, 'endDate', payload);
        },

        setTags(context, payload) {
            Vue.set(context.state.filterModel, 'tags', payload);
        },

        setTabsSelectPieceData(context, payload) {
            Vue.set(context.state, 'tabsSelectPieceName', payload);
        }
    }
};
